import { Globe } from "lucide-react";
import { cn } from "@/lib/utils";

interface Props {
  isEnabled: boolean;
  onToggle: () => void;
}

export const WebSearchToggle = ({ isEnabled, onToggle }: Props) => (
  <button
    type="button"
    aria-pressed={isEnabled}
    onClick={onToggle}
    className={cn(
      "inline-flex w-fit items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium transition-colors",
      {
        "border-brand-gold-300 bg-brand-gold-50 text-brand-gold-700": isEnabled,
        "bg-ivory-mist-50 border-desert-sand-200 text-muted-foreground hover:border-desert-sand-300 hover:bg-ivory-mist-100 hover:text-foreground":
          !isEnabled,
      },
    )}
  >
    <Globe size={14} />
    Web Search
  </button>
);
